
import 'keen-slider/keen-slider.min.css';
import KeenSlider from 'keen-slider';
import respUtility from '@/mixins/respUtility';
import placeholder from '@/assets/placeholder-animation.svg';
import { htmlspecialcharsDecode } from '~/mixins/helpers';

export default {
  name: 'AllFurnitureViewTrendingFurniture',
  mixins: [respUtility],
  data() {
    return {
      loaded: [true],
      slider: null,
      current: 0,
      activeSliders: 6,
      slidersLength: 0,
      arrowDisabled: false,
      placeholder,
    };
  },
  props: {
    products: {
      type: Array,
    },
    sliderBreakpoints: {
      type: Object,
      default: () => ({
        '(min-width: 768px)': {
          disabled: false,
          slides: { perView: 3, spacing: 16 },
          drag: true,
        },
        '(min-width: 1024px)': {
          disabled: false,
          slides: { perView: 5, spacing: 16 },
          drag: true,
        },
        '(min-width: 1264px)': {
          disabled: false,
          slides: { perView: 6, spacing: 24 },
          drag: true,
        },
      }),
    },
    staticArrows: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.products && this.products.length > 0) {
      this.$nextTick(() => {
        this.initSlider();
      });
    }
  },
  beforeDestroy() {
    if (this.slider) this.slider.destroy();
  },
  methods: {
    initSlider() {
      const { container } = this.$refs;
      if (!container) {
        return;
      }
      const breakpoint = this.sliderBreakpoints;

      const loadImages = (s) => {
        const idx = s.track.details.rel;
        const idxEnd = idx + (s.options?.slides?.perView || 1);
        // eslint-disable-next-line no-plusplus
        for (let i = idx; i < idxEnd; i++) {
          this.loaded[i] = true;
        }

        s.slides.forEach((element, index) => {
          if (!this.loaded[index]) {
            return;
          }
          const img = element.querySelector('img');
          if (img.dataset.src !== undefined) {
            img.setAttribute('src', img.dataset?.src);
            delete img.dataset.src;
          }
        });
        this.$forceUpdate();
      };

      if (!this.$isSpider) {
        this.slider = new KeenSlider(container, {
          loop: true,
          animationEnded: loadImages,
          created: loadImages,
          initial: this.current,
          disabled: true,
          slides: { perView: this.activeSliders, spacing: 16 },
          drag: true,
          breakpoints: breakpoint,
          slideChanged: (s) => {
            this.current = s.track.details.rel;
            this.updateArrowState();
          },
        });
        this.slidersLength = this.slider.track?.details?.slides?.length;
        this.updateArrowState();
      }
      if (this.$isSpider) {
        this.slider = new KeenSlider(container, {
          disabled: true,
        });
      }
    },

    updateArrowState() {
      if (this.slider && this.slider.track) {
        const totalSlides = this.slider.track.details.slides.length;
        this.arrowDisabled = totalSlides <= this.activeSliders;
      }
    },

    initLazyImg() {
      const lazyloadImages = document.querySelectorAll('.lazy-img.syte-item-image');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < lazyloadImages.length; i++) {
        if (lazyloadImages[i].dataset.src !== undefined) {
          lazyloadImages[i].setAttribute('src', lazyloadImages[i].dataset?.src);
          delete lazyloadImages[i].dataset.src;
        }
      }
    },

    decodeHtmlSpecialCharacters(value) {
      return htmlspecialcharsDecode(value);
    },
  },
};
